import type {
  ContaFinanceiraGerencialApi,
  ContasFinanceirasGerencialApi,
  ConciliacaoSaldoEfiApi,
} from "../types/contas-financeiras.types";
import { saldoOperacionalConta } from "../types/contas-financeiras.types";

function round2(n: number): number {
  return Math.round(n * 100) / 100;
}

export function recalcularTotaisConsolidados(
  contas: ContaFinanceiraGerencialApi[],
): Pick<
  ContasFinanceirasGerencialApi,
  "saldoConsolidado" | "saldoConsolidadoExtrato"
> {
  let saldoConsolidado = 0;
  let saldoConsolidadoExtrato = 0;

  for (const c of contas) {
    if (!c.ativo) continue;
    saldoConsolidadoExtrato += c.saldoAtual;
    saldoConsolidado += saldoOperacionalConta(c);
  }

  return {
    saldoConsolidado: round2(saldoConsolidado),
    saldoConsolidadoExtrato: round2(saldoConsolidadoExtrato),
  };
}

export function aplicarSaldoEfiNaContaGateway(
  contas: ContaFinanceiraGerencialApi[],
  parsed: { saldoDisponivel: number; bloqueioTotal: number },
): ContaFinanceiraGerencialApi[] {
  const consultadoEm = new Date().toISOString();
  return contas.map((c) => {
    if (c.codigoInterno !== "GATEWAY_EFI") return c;
    return {
      ...c,
      saldoEfiDisponivel: parsed.saldoDisponivel,
      saldoEfiBloqueio: parsed.bloqueioTotal,
      saldoEfiDivergencia: round2(parsed.saldoDisponivel - c.saldoAtual),
      saldoEfiConsultadoEm: consultadoEm,
      saldoEfiErro: null,
    };
  });
}

/** Limite de transferência: min(extrato, saldo Efí API) quando gateway. */
export function saldoDisponivelTransferencia(
  conta: ContaFinanceiraGerencialApi,
): number {
  if (conta.codigoInterno === "GATEWAY_EFI") {
    const extrato = conta.saldoAtual;
    if (
      conta.saldoEfiDisponivel != null &&
      Number.isFinite(conta.saldoEfiDisponivel)
    ) {
      return round2(Math.min(extrato, conta.saldoEfiDisponivel));
    }
    return extrato;
  }
  return conta.saldoAtual;
}

const LIMITE_DIVERGENCIA = 0.01;

export function temDivergenciaSaldoEfi(conta: ContaFinanceiraGerencialApi): boolean {
  if (conta.saldoEfiDivergencia == null) return false;
  return Math.abs(conta.saldoEfiDivergencia) > LIMITE_DIVERGENCIA;
}

export function mensagemConciliacaoSaldoEfi(c: ConciliacaoSaldoEfiApi): string {
  if (!c.aplicada) {
    return c.motivo ?? "Nenhum ajuste necessário.";
  }
  if (c.valor == null) return "Saldo conciliado.";
  const tipo = c.tipo === "ENTRADA" ? "entrada" : "saída";
  const valor = c.valor.toFixed(2).replace(".", ",");
  const antes = (c.saldoExtratoAntes ?? 0).toFixed(2).replace(".", ",");
  const depois = (c.saldoExtratoDepois ?? 0).toFixed(2).replace(".", ",");
  return `Extrato conciliado: ${tipo} de R$ ${valor} (extrato R$ ${antes} → R$ ${depois}).`;
}
